import { Row } from "rsuite";
import styled from "styled-components";


export const StyledRow = styled(Row)`
    display: flex;
    align-items: center;
    background-color: transparent;
    padding: 6px 12px;
    border-radius: 10px;
    margin-top: 12px;
    margin-bottom: 6px;
`;

export const ContainerLogoTitle = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    flex-direction: row;
    margin-right: 10px;
    margin-top: 10px;
    margin-left: 10px;
    margin-bottom: 10;
    gap: 10;        
`;

export const ContainerSize = styled.div`
    display: flex;
    flex-direction: column;
    margin: 3px;
    max-height: 60vh;
    overflow-y: auto;
    padding-bottom:  ${({ hasTamanhos }) => hasTamanhos ? 0 : '50px'};
`;

export const ContainerChecked = styled.div`
    display: flex;
    justify-content: end;
`;